import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import ModalInc from '../../../../../../../shared-ui/ModalInc/index';
import { policyActions } from '../../../../../../../lib/requests.es6';

export default function ChangeStatusToIssued(props) {
  var open = props.open;
  var onClose = props.onClose;
  var policy = props.policy;
  var onSuccess = props.onSuccess;

  var [loading, setLoading] = React.useState(false);
  var [error, setError] = React.useState(null);
  var [success, setSuccess] = React.useState(false);

  var handleClose = function () {
    if (loading) return;
    setError(null);
    setSuccess(false);
    onClose && onClose();
  };

  var handleConfirm = function () {
    setLoading(true);
    setError(null);

    policyActions({ policy_guid: policy.guid, body: { issued: true } })
      .then(function () {
        setLoading(false);
        setSuccess(true);
        onSuccess && onSuccess();
      })
      .catch(function (e) {
        setLoading(false);
        var message = 'An unexpected error occurred';
        if (e.response && e.response.data) {
          if (e.response.data.details && e.response.data.details.message) {
            message = e.response.data.details.message;
          } else if (e.response.data.message) {
            message = e.response.data.message;
          } else if (e.response.data.error) {
            message = e.response.data.error;
          }
        }
        setError(message);
      });
  };

  if (!policy) return null;

  var modalButtons = success
    ? [
        <button
          key="close"
          onClick={handleClose}
          style={{ padding: '8px 20px', cursor: 'pointer' }}
        >
          Close
        </button>,
      ]
    : [
        <button
          key="cancel"
          onClick={handleClose}
          disabled={loading}
          style={{ padding: '8px 20px', cursor: 'pointer', marginRight: '8px', background: '#f0f0f0', border: 'none', borderRadius: '4px' }}
        >
          Cancel
        </button>,
        <button
          key="confirm"
          onClick={handleConfirm}
          disabled={loading}
          style={{
            padding: '8px 20px',
            cursor: loading ? 'not-allowed' : 'pointer',
            background: '#032a37',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
          }}
        >
          {loading ? <CircularProgress size={14} style={{ color: 'white', verticalAlign: 'middle' }} /> : 'Confirm'}
        </button>,
      ];

  return (
    <ModalInc
      open={!!open}
      close={handleClose}
      modalTitle="Change Status to Issued"
      subTitle={
        success
          ? null
          : 'Policy Number: ' + (policy.policy_number || '')
      }
      fullWidth
      maxWidth="sm"
      modalButtons={modalButtons}
    >
      {success ? (
        <Typography variant="body1" style={{ color: '#155724', textAlign: 'center', padding: '10px 0' }}>
          Policy marked as issued successfully.
        </Typography>
      ) : (
        <>
          <Typography variant="body2" style={{ marginTop: '8px' }}>
            Are you sure you want to change this policy status to Issued?
          </Typography>
          {error && (
            <Typography variant="body2" style={{ color: '#721c24', marginTop: '10px' }}>
              {error}
            </Typography>
          )}
        </>
      )}
    </ModalInc>
  );
}
